// extracted by mini-css-extract-plugin
export default {"root":"J2__qI","icon":"klQGNR","ltr":"tIDsUd","withCount":"CNB1mg","badge":"VzaX_Y","rtl":"ISA1LS"};